import PropTypes from 'prop-types';
import React, { useEffect, useState } from "react";
import { Button, Modal } from 'semantic-ui-react';
import { GetReservation, SaveReservation } from "../../api/services/pms";
import { useTextResources } from "../../language";
import { onError, onSuccess, onWarning } from "../shared/messages";
import { useLoader } from "../../hooks/useLoader";
import { Currencies } from "../shared/currencies";
import ExtraAddonsGrid from './ExtraAddonsGrid';
import "./style.less";

const ExtraAddonsPopup = ({ reservation, controller, ...rest }) => {
    const text = useTextResources()
    const loader = useLoader();

    const [isOpen, setIsOpen] = useState(rest.open)
    const [data, setData] = useState([])
    const [dataForDeletion, setDataForDeletion] = useState([])
    const [reservationFromDB, setReservation] = useState([])
    const [insufficientAddon, setInsufficientAddon] = useState(false);
    useEffect(() => {
        if (rest.open === true && reservation?.Id)
            initialData(reservation?.Id)
    }, [rest.open]);

    useEffect(() => {
        if (controller) {
            window[controller] = async (action, params) => {
                switch (action) {
                    case "open":
                        if (params.Reservation)
                            if (params.Reservation.Id == 0) {
                                setData(params.Reservation.ReservationDailyAddons)
                                setReservation(params.Reservation)
                            }
                            else
                                initialData(params.Reservation.Id)
                        setIsOpen(true)
                        break;
                    default:
                        break;
                }
            }
        }
    }, [])

    const initialData = (id) => {
        (async () => {
            try {

                loader(true);
                const [dailyAddons] = await Promise.all([
                    GetReservation({
                        Ids: [id],
                        IncludeAddonsWithChainAndDiningRooms: true,
                        IncludeReservationDailyAccommodations: true,
                        IncludeTotalAmounts: true,
                        IncludeDayAmounts: true,
                        IncludeHotelAddons: true,
                        IncludeRate: true
                    }),
                ])
                setData(dailyAddons.ReservationDailyAddons)
                setReservation(dailyAddons)
            } catch (err) {
                onError(err)
            } finally {
                loader(false);
            }
        })()
    }

    const closeHandler = (updatedReservation) => {
        rest?.onClose?.(updatedReservation)
        setData([])
        setIsOpen(false)
    }

    const save = async () => {
        try {
            if (insufficientAddon) {
                onWarning("Addon has insufficient quantity")
                return false;
            }
            loader(true);
            const validatedData = data.filter(x => {
                if (!x.HotelAddonId) return false;
                const quantity =
                    Number(x.Quantity ?? 0) +
                    Number(x.AdultQuantity ?? 0) +
                    Number(x.ChildQuantity ?? 0) +
                    Number(x.InfantQuantity ?? 0);

                return quantity > 0;
            });
            if(data.length !== validatedData.length){
                onWarning("Some addons have zero quantity. Please update the quantity or remove the add-on row before saving.")
                loader(false);
                return;
            }
            const reservationDailyAddons = [...validatedData, ...dataForDeletion];
            reservationFromDB.ReservationDailyAddons = reservationDailyAddons;
            var updatedReservation = await SaveReservation(reservationFromDB)
            rest?.reservationDailyAddonsExist?.(data?.length > 0)
            onSuccess()
            closeHandler(updatedReservation)
        }
        catch (error) {
            onWarning(error)
        }
        finally {
            loader(false);
        }
    }
    return <Modal open={isOpen} {...rest} size="large" onClose={() => closeHandler()}>
        <Modal.Header>{text("Addons")}</Modal.Header>
        <Modal.Content>
            {reservationFromDB && <ExtraAddonsGrid
                reservation={reservationFromDB}
                data={data}
                setData={setData}
                setDataForDeletion={setDataForDeletion}
                hotelId={reservationFromDB?.HotelId}
                startDate={reservationFromDB?.CheckInDate}
                endDate={reservationFromDB?.CheckOutDate}
                rateId={reservationFromDB?.RateId || reservationFromDB?.Rate?.Id}
                insufficientAddon={insufficientAddon}
                setInsufficientAddon={setInsufficientAddon}
            />
            }
        </Modal.Content>
        <Modal.Description>
            <p style={{ fontWeight: 'bold', paddingBottom: '20px', paddingLeft: '20px' }}>{text('TotalPrice')}{' '}{reservationFromDB?.TotalAmountAddons?.toFixed(2)} {Currencies[reservationFromDB?.CurrencyId]?.symbol || ''}</p>
        </Modal.Description>
        <Modal.Actions>
            <Button negative size="small" onClick={() => closeHandler()}>{text("Cancel")}</Button>
            <Button positive size="small" onClick={save}>{text("Save")}</Button>
        </Modal.Actions>
    </Modal >
}
ExtraAddonsPopup.propTypes = {
    reservation: PropTypes.any,
    open: PropTypes.any,
    row: PropTypes.object,
    onCancelChanges: PropTypes.func,
    setTemplates: PropTypes.func,
    extendedProps: PropTypes.object,
    controller: PropTypes.string
}
export default ExtraAddonsPopup;
